import React, { useState, useEffect, useContext } from "react";
import {
  Box, Grid, Card, Typography, Button, TextField, Select, MenuItem,
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Menu, Tooltip
} from "@mui/material";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import moment from "moment";
import { saveDataDB, getDataDB, sendEmail, emailBookNowForm } from "../api";
import { AppContext, siteName } from "../main";
import Navbar from "../layout/Navbar";

// import { Box, Typography, IcåonButton, Tooltip } from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { HomeMiniSharp, HomeSharp } from "@mui/icons-material";

export default function SchedulerPage() {
  const { myContext = {}, setMyContext } = useContext(AppContext);
  const { 
    //myInfo = {},
     appointmentTypes = [], availability = {}, bookings = [] } = myContext;
  const myInfo = {};
  useEffect(() => {
    const loadData = async () => {
      const [types, avail, bookings] = await Promise.all([
        loadAppointmentTypes(siteName),
        loadAvailability(siteName),
        loadBookings(siteName)
      ]);
      setMyContext(existing => ({ ...existing, appointmentTypes: types, availability: avail, bookings }));
    };
    loadData();
  }, [siteName, setMyContext]);

  return (
    <Box p={3} sx={{ background: "#f5f5f5", minHeight: "100vh" }}>
      <Header />
      <div style={{
        paddingTop:70
      }} />
      {myInfo?.title == 'admin' ? <AdminCalendar /> : <GuestBooking />}
      <Footer />
    </Box>
  );
}

function AdminCalendar() {
  const { myContext = {}, setMyContext } = useContext(AppContext);
  const { appointmentTypes = [], availability = {}, myInfo = {}} = myContext;
  //const myInfo = {};
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [newAppt, setNewAppt] = useState({ name: "", description: "", duration: 15 });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [slotTime, setSlotTime] = useState("09:00");
  const [selectedType, setSelectedType] = useState("");
  const [capacity, setCapacity] = useState(1);

  const [slotMenus, setSlotMenus] = useState({});
  const [typeMenus, setTypeMenus] = useState({});

  const dateStr = selectedDate.toISOString().split('T')[0];
  const daySlots = availability[dateStr] || [];

  const handleAddType = async () => {
    const appt = { ...newAppt, siteName };
    await saveAppointmentTypeDB(appt);
    const updatedTypes = await loadAppointmentTypes(siteName);
    setMyContext(existing => ({ ...existing, appointmentTypes: updatedTypes }));
    setDialogOpen(false);
    setNewAppt({ name: "", description: "", duration: 15 });
  };

  const handleDeleteType = async (_id) => {
    await saveDataDB({
      query: { _id, deleted: true },
      keys: ["_id"],
      resource: `${siteName}_scheduling_types`
    });
    const updatedTypes = await loadAppointmentTypes(siteName);
    setMyContext(existing => ({ ...existing, appointmentTypes: updatedTypes }));
  };

  const handleAddSlot = async () => {
    if (!selectedType || !slotTime) return alert("Select type and time");
    const slot = { typeId: selectedType, startTime: slotTime, capacity };
    const updated = [...daySlots, slot];
    await saveAvailabilityDB({ siteName, dateStr, slots: updated });
    const updatedAvailability = await loadAvailability(siteName);
    setMyContext(existing => ({ ...existing, availability: updatedAvailability }));
  };

  const handleDeleteSlot = async (index) => {
    const updatedSlots = [...daySlots];
    updatedSlots.splice(index, 1);
    await saveAvailabilityDB({ siteName, dateStr, slots: updatedSlots });
    const updatedAvailability = await loadAvailability(siteName);
    setMyContext(existing => ({ ...existing, availability: updatedAvailability }));
  };

  return (
    <Box>
      <Typography variant="h5" mb={3} fontWeight="bold" color="black">Admin Scheduler</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Calendar value={selectedDate} onChange={setSelectedDate} />
          <Typography variant="h6" mt={2} color="black">Availability for {dateStr}</Typography>

          {daySlots.map((slot, idx) => {
            const appt = appointmentTypes.find(a => a._id === slot.typeId);
            return (
              <Card key={idx} sx={{ p: 2, mb: 1, position: 'relative' }}>
                <div style={{
                  position: 'relative', flexDirection: 'row', display: 'flex',
                  justifyContent: 'space-between'
                }}>
                  <div style={{
                    flexDirection: 'column', display: 'flex',
                  }}>
                    <Typography color="black">{appt?.name || ""}</Typography>
                    <Typography color="black">{formatTime(slot.startTime)} ({appt?.duration} min)</Typography>
                    <Typography color="black">Capacity: {slot.capacity}</Typography>
                  </div>

                  <div
                    onClick={(e) => setSlotMenus(prev => ({ ...prev, [idx]: e.currentTarget }))}
                  >
                    <MoreVertIcon />
                  </div>
                </div>

                {myInfo?.handle && <Menu
                  anchorEl={slotMenus[idx]}
                  open={Boolean(slotMenus[idx])}
                  onClose={() => setSlotMenus(prev => ({ ...prev, [idx]: null }))}
                >
                  <MenuItem onClick={() => { handleDeleteSlot(idx); setSlotMenus(prev => ({ ...prev, [idx]: null })); }}>Delete</MenuItem>
                </Menu>}
              </Card>
            );
          })}

          <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
            <Select value={selectedType} onChange={e => setSelectedType(e.target.value)} fullWidth>
              <MenuItem value="">Select Type</MenuItem>
              {appointmentTypes.filter(a => !a.deleted).map(a => (
                <MenuItem key={a._id} value={a._id}>{a.name}</MenuItem>
              ))}
            </Select>
            <TextField label="Start Time" type="time" value={slotTime} onChange={e => setSlotTime(e.target.value)} fullWidth />
            <TextField label="Capacity" type="number" value={capacity} onChange={e => setCapacity(parseInt(e.target.value) || 1)} fullWidth />
            <Button variant="contained" onClick={handleAddSlot}>Add Slot</Button>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="h6" color="black">Appointment Types</Typography>
          <Box sx={{ maxHeight: 400, overflowY: "auto" }}>
            {appointmentTypes.filter(a => !a.deleted).map((a, idx) => (
              <Card key={a._id} sx={{
                p: 2, mb: 1, position: 'relative', flexDirection: 'row', display: 'flex',
                justifyContent: 'space-between'
              }}>
                <div style={{
                  flexDirection: 'column', display: 'flex',
                }}>
                  <Typography fontWeight="bold" color="black">{a.name}</Typography>
                  <Typography color="black">{a.description}</Typography>
                  <Typography color="black">{a.duration} mins</Typography>
                </div>
                <div
                  sx={{ position: 'absolute', top: 8, right: 8 }}
                  onClick={(e) => setTypeMenus(prev => ({ ...prev, [idx]: e.currentTarget }))}
                >
                  <MoreVertIcon />
                </div>

                <Menu
                  anchorEl={typeMenus[idx]}
                  open={Boolean(typeMenus[idx])}
                  onClose={() => setTypeMenus(prev => ({ ...prev, [idx]: null }))}
                >
                  <MenuItem onClick={() => { handleDeleteType(a._id); setTypeMenus(prev => ({ ...prev, [idx]: null })); }}>Delete</MenuItem>
                </Menu>
              </Card>
            ))}
          </Box>

          <Button variant="contained" sx={{ mt: 2 }} onClick={() => setDialogOpen(true)}>Add Type</Button>
        </Grid>
      </Grid>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Add Appointment Type</DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField label="Name" value={newAppt.name} onChange={e => setNewAppt({ ...newAppt, name: e.target.value })} />
          <TextField label="Description" value={newAppt.description} onChange={e => setNewAppt({ ...newAppt, description: e.target.value })} />
          <TextField label="Duration (mins)" type="number" value={newAppt.duration} onChange={e => setNewAppt({ ...newAppt, duration: parseInt(e.target.value) })} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleAddType}>Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

function GuestBooking() {
  const { myContext = {} } = useContext(AppContext);
  const { appointmentTypes = [], availability = {}, bookings = [] } = myContext;

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [confirming, setConfirming] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const dateStr = selectedDate.toISOString().split('T')[0];
  const now = moment();

  const slots = (availability[dateStr] || []).filter(slot => {
    const slotTime = moment(`${dateStr} ${slot.startTime}`, "YYYY-MM-DD HH:mm");
    const totalBookings = bookings.filter(b => b.dateStr === dateStr && b.startTime === slot.startTime).length;
    return slotTime.isAfter(now) && totalBookings < (slot.capacity || 1);
  });

  const handleConfirm = async () => {
    if (!name || !email || !email.includes("@")) {
      alert("Please enter valid name and email.");
      return;
    }
    const appt = appointmentTypes.find(a => a._id === selectedSlot.typeId);
    const formData = {
      siteName,
      dateStr,
      startTime: selectedSlot.startTime,
      typeInfo: appt,
      name, email, phone,
      createdAt: moment()
    };

    await saveBookingToDB(formData);
    await sendEmail(emailBookNowForm({ ...formData, emails: email, siteName }));

    alert("Booking Confirmed");
    setSelectedSlot(null);
    setConfirming(false);
    setName(""); setEmail(""); setPhone("");
  };

  return (
    <Box>
      <Typography variant="h5" mb={3} fontWeight="bold" color="black">Book Appointment</Typography>
      <Calendar value={selectedDate} onChange={setSelectedDate} />
      <Box mt={3}>
        {slots.length === 0 && <Typography>No availability for {dateStr}</Typography>}
        {slots.map((slot, idx) => {
          const appt = appointmentTypes.find(a => a._id === slot.typeId);
          return (
            <Card key={idx} sx={{ p: 2, mb: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Box>
                <Typography fontWeight="bold" color="black">{appt?.name}</Typography>
                <Typography color="black">Time: {formatTime(slot.startTime)}</Typography>
              </Box>
              <Button variant="contained" onClick={() => { setSelectedSlot(slot); setConfirming(true); }}>Select</Button>
            </Card>
          );
        })}
      </Box>

      <Dialog open={confirming} onClose={() => setConfirming(false)}>
        <DialogTitle>Confirm Booking</DialogTitle>
        <DialogContent>
          <Typography>Date: {dateStr}</Typography>
          <Typography>Time: {formatTime(selectedSlot?.startTime)}</Typography>
          <TextField fullWidth label="Your Name" value={name} onChange={(e) => setName(e.target.value)} sx={{ mt: 2 }} />
          <TextField fullWidth label="Your Email" value={email} onChange={(e) => setEmail(e.target.value)} sx={{ mt: 2 }} />
          <TextField fullWidth label="Phone (optional)" value={phone} onChange={(e) => setPhone(e.target.value)} sx={{ mt: 2 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirming(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleConfirm}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

const formatTime = (timeStr) => {
  if (typeof timeStr !== 'string') return '';
  const [hour, minute] = timeStr.split(":");
  const hourNum = parseInt(hour);
  const period = hourNum >= 12 ? "PM" : "AM";
  const hourDisplay = hourNum % 12 === 0 ? 12 : hourNum % 12;
  return `${hourDisplay}:${minute} ${period}`;
};


// Header & Footer same as yours — keep unchanged


const Header = () => {
  const { myContext = {} } = useContext(AppContext);
  const { myInfo = {} } = myContext;

  return (
    <header id="header-wrap" style={{
      // marginBottom:30
    }}>
    <Navbar
      navEdit={true}
    />
         </header>
  );
};
const Footer = () => (
  <Box sx={{ textAlign: "center", py: 3, mt: 5, borderTop: "1px solid #ddd" }}>
    <Typography variant="body2" color="text.secondary">
      © {new Date().getFullYear()} Vare Technologies. All rights reserved.
    </Typography>
  </Box>
);

// DATABASE API CALLS
async function saveAppointmentTypeDB(appt) {
  return saveDataDB({ query: { ...appt, date: moment() }, keys: ["siteName", "name"], resource: `${siteName}_scheduling_types` });
}
async function saveAvailabilityDB(data) {
  return saveDataDB({ query: { ...data, date: moment() }, keys: ["siteName", "dateStr"], resource: `${siteName}_scheduling_availability` });
}
async function saveBookingToDB(data) {
  return saveDataDB({ query: data, keys: ["siteName", "dateStr", "startTime"], resource: `${siteName}_scheduling_bookings` });
}
async function loadAppointmentTypes(siteName) {
  const res = await getDataDB({ query: { siteName }, resource: `${siteName}_scheduling_types` });
  return Array.isArray(res) ? res.filter(a => !a.deleted) : [];
}
async function loadAvailability(siteName) {
  const res = await getDataDB({ query: { siteName }, resource: `${siteName}_scheduling_availability` });
  const mapped = {};
  (Array.isArray(res) ? res : []).forEach(row => { mapped[row.dateStr] = row.slots; });
  return mapped;
}
async function loadBookings(siteName) {
  const res = await getDataDB({ query: { siteName }, resource: `${siteName}_scheduling_bookings` });
  return Array.isArray(res) ? res : [];
}
